import { useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import styled from 'styled-components';

import { PageLoader } from '@soluto-private/mx-asurion-ui-react';

import {
  useCurrentPath,
  useGoToNextStep,
} from '@service-initiation/shared-data-access-flow-manager';
import { useFooter } from '@service-initiation/shared-ui-footer';

type FlowContainerProps = {
  children: JSX.Element;
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 700px;
`;
export const FlowContainer = ({
  children,
}: FlowContainerProps): JSX.Element => {
  const currentPath = useCurrentPath();
  const [loading, setLoading] = useState(true);
  const [{ error, loading: loadingNextStep }, goToNextStep] = useGoToNextStep();

  useFooter();

  useEffectOnce(() => {
    goToNextStep({ stopAtPath: currentPath });
    setLoading(false);
  });

  useEffect(() => {
    if (error) {
      throw error;
    }
  }, [error]);

  return loading || loadingNextStep ? (
    <Container>
      <PageLoader />
    </Container>
  ) : (
    children
  );
};
